export const THULIUM_API = 'https://api.thulium.com'
export const THULIUM_SUPPORT = 'https://support.thulium.com'
export const INSTANCE_LOGIN = 'https://admin.thulium.com/login/instance'
const INSTANCE_REGISTER = 'https://admin.thulium.com/register'
export const LINKEDIN = 'https://www.linkedin.com/company/thulium'
export const FACEBOOK = 'https://www.facebook.com/thulium'
export const YOUTUBE = 'https://www.youtube.com/channel/UC4JAdgU_tCgOK3NT2lDqF8Q'
export const PARTNERS =
    'https://docs.google.com/forms/d/e/1FAIpQLSdb5k-PJUGeVWKBvfn_bFjWjToCz9E7WLmYsSjXddA9jD_BzA/viewform'

export const CONTACT_FORM = `${process.env.ADMIN_APP_URL}/contact_form`
export const PRESENTATION_FORM = `${process.env.ADMIN_APP_URL}/presentation_form`
export const PARTNERS_FORM = `${process.env.ADMIN_APP_URL}/partners_form`
export const NEWSLETTER_FORM = `${process.env.ADMIN_APP_URL}/newsletter_form`
export const EBOOK_FORM = `${process.env.ADMIN_APP_URL}/ebook_form`
export const DSA_FORM = `${process.env.ADMIN_APP_URL}/abuse_form`

export const getRegisterPath = (partnerName, valueTrack) => {
    const url = new URL(INSTANCE_REGISTER)
    if (partnerName) {
        url.searchParams.append('p', partnerName)
    }
    if (valueTrack) {
        url.searchParams.append('campaignid', valueTrack.campaignId || '')
        url.searchParams.append('adgroupid', valueTrack.groupId || '')
        url.searchParams.append('keyword', valueTrack.keyword || '')
        url.searchParams.append('gclid', valueTrack.gclId || '')
    }
    return url.toString()
}
export const DEMO_FORM = `${process.env.ADMIN_APP_URL}/registration_form`
